// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__IxcXc","left":"styles_left__r8Kez"};